module.exports = __webpack_public_path__ + "img/dsci0016.aea1a66c.jpg";